import { SET_VISITED_LIST, SET_IP_LOCATION, SET_FOOTER_LOCATIONS, SET_SEARCH_HISTORY, SET_AVAILABILITY, SET_BOOKUN_WEBHOOK, SET_FAREHARBOR_WEBHOOK } from "./global.types";


export const setVisitedList = (payload) => ({
    type: SET_VISITED_LIST,
    payload
});


export const setIPLocation = (payload) => ({
    type: SET_IP_LOCATION,
    payload
});

export const setFooterLocations = (payload) => ({
    type: SET_FOOTER_LOCATIONS,
    payload
});

export const setSearchHistory = (payload) => ({
    type: SET_SEARCH_HISTORY,
    payload
});

export const setAvailability = (val) => ({
    type: SET_AVAILABILITY,
    payload: val
});

export const setBookunWebhook = (val) => ({
    type: SET_BOOKUN_WEBHOOK,
    payload: val
});

export const setFareharborWebhook = (val) => ({
    type: SET_FAREHARBOR_WEBHOOK,
    payload: val
});


